import { createTheme, darken, lighten } from '@mui/material/styles'
import { ptBR } from '@mui/material/locale'
import Colors from './Colors'

const baseColor = Colors.primaryColor
const contrastColor = Colors.accentColor

export const clientLogo = 'assets/images/logos/client_logo.png'

export default {
  palette: {
    primary: baseColor,
    contrast: contrastColor,
    gray: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    error: 'red',
  },
  shadows: {
    0: 'none',
    1: '0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)',
    2: '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
    3: '0px 1px 8px 0px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)',
    4: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    5: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    6: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    7: '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    8: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    9: '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    10: '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    11: '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    12: '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    13: '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    14: '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    15: '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    16: '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    17: '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    18: '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    19: '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    20: '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    21: '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    22: '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    23: '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    24: '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  },
}

export const materialTheme = createTheme(
  {
    palette: {
      primary: {
        main: baseColor,
        hover: Colors.hover,
        bg: '#fff',
        dark: darken(baseColor, 0.1),
        darker: '#070f20',
        light: lighten(baseColor, 0.2),
        lighter: '#fff',

        orange: '#ed9900',
        gray: '#808080',
        grayDark: '#666666',
        grayLight: '#cccccc',
        grayLight2: '#999999',
        grayPaper: '#f8f8f8',

        black: '#000000',
        green: Colors.green,
        greenHover: darken(Colors.green, 0.9),
        red: Colors.red,
        yellow: Colors.yellow,
      },
      secondary: {
        main: '#343a40',
        hover: '#61656b',
      },
      third: {
        main: '#19D315',
        hover: '#019101',
      },
      success: {
        main: Colors.green,
        light: lighten(Colors.green, 0.1),
        dark: darken(Colors.green, 0.1),
      },
      info: {
        main: Colors.blue,
        light: lighten(Colors.blue, 0.1),
        dark: darken(Colors.blue, 0.1),
      },
      error: {
        main: Colors.red,
        light: lighten(Colors.red, 0.1),
        dark: darken(Colors.red, 0.1),
      },
      warning: {
        main: Colors.yellow,
        light: lighten(Colors.yellow, 0.1),
        dark: darken(Colors.yellow, 0.1),
      },
      background: {
        default: '#fff',
      },
    },
    typography: {
      htmlFontSize: 10,
      fontSize: 14,
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          fixedHeader: {
            backgroundColor: Colors.primaryColor,
            color: Colors.white,
            fontWeight: 600,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: 12,
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          selectLabel: {
            fontSize: '1.25rem',
          },
          displayedRows: {
            fontSize: '1.25rem',
          },
        },
      },
      MUIDataTableFilterList: {
        styleOverrides: {
          root: {
            marginBottom: 8,
          },
        },
      },
    },
  },
  ptBR,
)
